import Image, { StaticImageData } from 'next/image';
import React, { FC } from 'react';
import CommentAvatar from '@/components/(postTypes)/platforms/(archive)/layout/(review)/list/CommentAvatar';

interface ForecastItem {
    image?: string | StaticImageData;
    name: string;
    role: string;
    forecast: string;
}

interface PostForecastsProps {
    forecasts: ForecastItem[];
}
const PostForecasts: FC<PostForecastsProps> = ({ forecasts }) => {
    return (
        <>
            {forecasts?.map((forecast, index) => (
                <blockquote
                    key={index}
                    className='mx-auto flex justify-center rounded-lg border border-primary/30 p-4 dark:border-white/30'
                >
                    <div className='flex w-full flex-col items-start justify-center'>
                        <div className='!flex items-center gap-1'>
                            {forecast.image ? (
                                <Image
                                    className='!m-1 !h-24 !w-24 rounded-full border border-primary/30 bg-bg object-cover p-1 dark:border-white/30'
                                    width={1200}
                                    height={1200}
                                    src={forecast.image}
                                    alt={forecast.name || 'forcast_name'}
                                    title={forecast.name}
                                />
                            ) : (
                                <CommentAvatar className='!m-1 !h-24 !w-24 shrink-0 rounded-full border border-primary/30 p-1 dark:border-white/30' />
                            )}
                            <div className='flex flex-col items-center justify-start gap-2'>
                                <h2 className='!mt-0 !text-lg !font-semibold text-gray-800 dark:text-white'>
                                    {forecast.name}
                                </h2>
                                <h3 className='!m-0 !text-sm !text-gray-500'>{forecast.role}</h3>
                            </div>
                        </div>
                        <p className='!mb-0 text-center !text-base text-gray-600'>
                            {forecast.forecast}
                        </p>
                    </div>
                </blockquote>
            ))}
        </>
    );
};

export default PostForecasts;
